import * as yup from "yup";

/** Valores validados del envío automático de factura (cargar y enviar por email). */
export interface ChargedInvoiceAutomaticValues {
  ccEmail?: string | null;
}

/**
 * Esquema de validación para el envío automático de factura (cargar y enviar por email).
 */
export const chargedInvoiceAutomaticSchema: yup.ObjectSchema<ChargedInvoiceAutomaticValues> = yup
  .object()
  .shape({
    ccEmail: yup.string().email("Debe ser un correo válido"),
  })
  .required();
